import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Dialog, DialogTitle } from '@material-ui/core';
import { Button } from '@ipc/ipc-components';
import React, { useEffect, useState } from 'react';
import { AddContactDialogStyle } from '../components/AddContactDialog.styles';
import ListTable from '../../../../../common/list-table/components/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../common/list-table/actions/ListTableActions';
import {
  getAllContacts,
  getAllContactsColumns,
  getIsAllContactsLoading,
} from '../redux/selectors/MRDContactManagementSelectors';
import { associateMrdContactsRequestActionCreator } from '../redux/actions/ContactManagementActions';

function AddContactDialog(props) {
  const {
    openDialog,
    closeDialog,
    allContacts,
    tableLoad,
    loading,
    columns,
    associateContactRequest,
    selectedImpc,
  } = props;

  const [selectedContact, setSelectedContact] = useState(null);

  const handleOnClose = () => {
    setSelectedContact(null);
    closeDialog();
  };

  const handleOnClickContactTable = (state, rowInfo) => {
    if (rowInfo) {
      return {
        style: {
          background: rowInfo.original.id === selectedContact?.id ? '#dbffdb' : null,
        },
        onClick: () => {
          setSelectedContact(rowInfo.original);
        },
      };
    }
    return {};
  };

  const confirmSave = () => {
    associateContactRequest({
      contactId: selectedContact.id,
      impcCode: selectedImpc,
    });
    handleOnClose();
  };

  useEffect(() => {
    if (openDialog) tableLoad(TableDefinitions.ALL_CONTACTS.id);
  }, [openDialog]);

  return (
    <Dialog className="add-contact-dialog" onClose={closeDialog} aria-labelledby="simple-dialog-title" open={openDialog}>
      <AddContactDialogStyle>
        <DialogTitle id="simple-dialog-title">Add Contact to </DialogTitle>
        <div className="m">
          <ListTable
            listId={TableDefinitions.ALL_CONTACTS.id}
            loading={loading}
            data={allContacts}
            columns={columns}
            getTrProps={handleOnClickContactTable}
          />
        </div>
        <div className="after-box">
          <Button className="cancel" onClick={handleOnClose} id="cancel">Cancel</Button>
          <Button
            onClick={confirmSave}
            className={`primary-button-${selectedContact === null} after-box-submit`}
            disabled={selectedContact === null}
            id="submit"
          >
            Submit
          </Button>
        </div>
      </AddContactDialogStyle>
    </Dialog>
  );
}

AddContactDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.bool,
  allContacts: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  tableLoad: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.object),
  associateContactRequest: PropTypes.func,
  selectedImpc: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    allContacts: getAllContacts(state),
    loading: getIsAllContactsLoading(state),
    columns: getAllContactsColumns(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoad: tableLoadData,
  associateContactRequest: associateMrdContactsRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddContactDialog);
